import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {BaseComponent} from '../../basecomponent.js';


/* global customElements */
class ServiceAccountGrid extends BaseComponent {

	//remember if the attribute is added it's true
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
		
		var serviceAccountGrid = this;
		setTimeout(function(){
			serviceAccountGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var serviceAccountGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filtercompany',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;' + (serviceAccountGrid.admin ? '' : 'display: none;'),
					label: 'Company',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					postinit: function(combo) {
						if (serviceAccountGrid.admin) {
							Service.getCompanyService().getCompaniesLookup().then(function(data){
								combo.items = data;
							});
						}
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							var companyId = ElementUtil.query(toolbar, 'filtercompany').value;
							if (companyId) {
								ElementUtil.query(toolbar, 'add').disabled = false;
							} else {
								ElementUtil.query(toolbar, 'add').disabled = true;
							}							
							actionRefresh();
						}
					}					
				},							
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					disabled: true,	
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_SERVICE_ACCOUNTS:WRITE', 'API_SERVICE_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							addEditAction();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_SERVICE_ACCOUNTS:WRITE', 'API_SERVICE_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							addEditAction(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'updatestatus',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_SERVICE_ACCOUNTS:WRITE', 'API_SERVICE_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Toggle Status')
					],
					listeners: {
						click: function() {							
							actionActivateDisable(grid.selectedItems[0]);
						}
					}					
				},			
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right;' + (serviceAccountGrid.admin ? 'margin-top: 18px;' : ''),
					permissions: ['ADMIN_SERVICE_ACCOUNTS:DELETE', 'API_SERVICE_ACCOUNTS:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}
			]
		});
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},
			children: [				
				{						
					path: 'userId',
					header: 'User Id',
					width: '5em'						
				},
				{						
					path: 'apiKey',
					header: 'API Key',
					width: '5em'						
				},
				{						
					path: 'description',
					header: 'Description',
					width: '5em'
				},				
				{						
					path: 'contactFirstname',
					header: 'First Name',
					width: '5em'
				},							
				{						
					path: 'contactLastname',
					header: 'Last Name',					
					width: '5em'
				},
				{
					path: 'contactEmail',
					header: 'Email',					
					'text-align': 'center',
					'flex-grow': '1'
				},							
				{
					path: 'activeStatus',
					header: 'Active Status',					
					'text-align': 'center',
					width: '5em'
				},
				{
					path: 'status',
					header: 'Account Status',
					'text-align': 'center',
					width: '5em',
					renderer: function(root, column, rowData) {
						var status = 'Locked';						
						if (rowData.item.status === 'A') {
							status = "Open";																	
							root.classList.add('grid-item-success-highlight');
						} else {
							root.classList.add('grid-item-fail-highlight');
						}
						root.innerHTML = status;
					}				
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'updatestatus').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false; 						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'updatestatus').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true; 
					}	
				}
			}
		});
		
		var gridLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		serviceAccountGrid.append(gridLayout);
		
		
		//hide admin only options
		if (!serviceAccountGrid.admin) {
			//make sure it's rendered
			setTimeout(function(){
				ElementUtil.query(toolbar, 'filtercompany').classList.add('hide');			
			}, 10);
			ElementUtil.query(toolbar, 'add').disabled = false;			
		}
		
		var actionRefresh = function() {
					
			var currentFilter = {
			};
			
			if (serviceAccountGrid.admin) {
				var companyId = ElementUtil.query(toolbar, 'filtercompany').value;
				if (companyId) {
					var loadMask = grid.showLoading();
					
					currentFilter.companyId = companyId;
					
					Service.getApiService().getAPIServiceAccounts(currentFilter).then(function(users){
						grid.activeItem = null;
						grid.items = users.data;
						loadMask.remove();
					});
				}
			} else {
				var loadMask = grid.showLoading();
				Service.getApiService().getAPIServiceAccounts().then(function(users){						
					grid.activeItem = null;
					grid.items = users.data;
					loadMask.remove();
				});
			}
		};
		actionRefresh();
	
		var actionDelete = function(record) {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete service account <b>' + record.userId + '</b>? <br><br> This may impacted external integrations.',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting Service Account...');													
							
							Service.getApiService().deleteServiceAccount(record.userId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted Service Account: ' + record.userId, {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});
		};		
		
		var addEditAction = function(record) {				
			
			var handleAction = function(record, companyId) {				
				if (record) {

					var userWin = ElementUtil.create({
						tag: 'dl-dialog',
						title: 'Edit Sevice Account',
						icon: 'vaadin:edit',
						listeners: {
							ready: function () {
								userWin.show();

								var formPanel = ElementUtil.create({
									tag: 'dl-form-panel',
									itemid: 'form',
									children: [
										{
											tag: 'vaadin-form-layout',
											children: [
												{
													tag: 'vaadin-text-field',
													name: 'description',
													label: 'Description',
													required: true,
													colspan: 2,
													maxlength: 255
												}
											]
										},
										{
											tag: 'fieldset',
											children: [
												{
													tag: 'legend',
													innerHTML: 'Profile'
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-text-field',
															name: 'contactFirstname',
															label: 'Contact First Name',
															required: true,
															maxlength: 120
														},
														{
															tag: 'vaadin-text-field',
															name: 'contactLastname',
															label: 'Contact Last Name',
															required: true,
															maxlength: 120
														},
														{
															tag: 'vaadin-email-field',
															name: 'contactEmail',
															label: 'Contact Email',
															required: true,
															maxlength: 120
														},
														{
															tag: 'vaadin-text-field',
															name: 'contactPhone',
															label: 'Contact Phone',
															maxlength: 120
														}
													]
												}
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function () {

															//check passwords	
															var formData = formPanel.getData();
															if (formData.password !== formData.confirmPassword) {
																window.DL.MessageUtil.showOkMessage('New Password and Confirm Password need to be the same.');
															} else {
																formPanel.submitForm({
																	preSubmit: function (data) {
																		return data;
																	},
																	actualCall: function (data) {
																		if (companyId) {
																			data.companyId = companyId;
																		}
																		data.username = record.userId;
																		return Service.getApiService().saveAPIServiceAccount(data, true);
																	},
																	success: function (data, responseData) {
																		window.DL.MessageUtil.showToast('Success', 'Added Service Account', {
																			theme: 'success',
																			position: 'top-stretch'
																		});
																		actionRefresh();
																		userWin.close();
																	}
																});
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															userWin.close();
														}
													}
												}
											]
										}
									]
								});

								userWin.addToContentElement(formPanel);

								formPanel.load(record);

							}
						}
					});

				} else {

					var addWin = ElementUtil.create({
						tag: 'dl-dialog',
						title: 'Add Service Account',
						icon: 'vaadin:plus',
						listeners: {
							ready: function () {
								addWin.show();

								var formPanel = ElementUtil.create({
									tag: 'dl-form-panel',
									itemid: 'form',
									children: [
										{
											tag: 'vaadin-form-layout',
											children: [
												{
													tag: 'vaadin-text-field',
													name: 'description',
													label: 'Description',
													required: true,
													colspan: 2,
													maxlength: 255
												}
											]
										},
										{
											tag: 'fieldset',
											children: [
												{
													tag: 'legend',
													innerHTML: 'Profile'
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-text-field',
															name: 'contactFirstname',
															label: 'Contact First Name',
															required: true,
															maxlength: 120
														},
														{
															tag: 'vaadin-text-field',
															name: 'contactLastname',
															label: 'Contact Last Name',
															required: true,
															maxlength: 120
														},
														{
															tag: 'vaadin-email-field',
															name: 'contactEmail',
															label: 'Contact Email',
															required: true,
															maxlength: 120
														},
														{
															tag: 'vaadin-text-field',
															name: 'contactPhone',
															label: 'Contact Phone',
															maxlength: 120
														}
													]
												}
											]
										},
										{
											tag: 'fieldset',
											children: [
												{
													tag: 'legend',
													innerHTML: 'Security'
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'vaadin-combo-box',
															'class': 'spacer-toolbar-item',
															style: 'width: 250px;',
															label: 'Role',
															name: 'roleId',
															'item-value-path': 'roleId',
															'item-label-path': 'roleName',
															required: true,
															postinit: function (combo) {
																Service.getSecurityService().getSecurityRoles(companyId).then(function (data) {
																	combo.items = data;
																});
															},
															placeHolder: 'Select'
														}
													]
												}
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function () {

															//check passwords	
															var formData = formPanel.getData();
															if (formData.password !== formData.confirmPassword) {
																window.DL.MessageUtil.showOkMessage('New Password and Confirm Password need to be the same.');
															} else {
																formPanel.submitForm({
																	preSubmit: function (data) {
																		return data;
																	},
																	actualCall: function (data) {
																		if (companyId) {
																			data.companyId = companyId;
																		}
																		return Service.getApiService().saveAPIServiceAccount(data);
																	},
																	success: function (data, responseData) {
																		window.DL.MessageUtil.showToast('Success', 'Added Service Account', {
																			theme: 'success',
																			position: 'top-stretch'
																		});
																		actionRefresh();
																		addWin.close();
																	}
																});
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {
															addWin.close();
														}
													}
												}
											]
										}
									]
								});

								addWin.addToContentElement(formPanel);
							}
						}
					});

				}
			};
			

			if (serviceAccountGrid.admin) {
				var companyId = ElementUtil.query(toolbar, 'filtercompany').value;
				handleAction(record, companyId);
			} else {
				Service.getCompanyService().getCurrentCompany().then(function(fullCompany){
					var companyId = fullCompany.company.companyId;
					handleAction(record, companyId);			
				}); 				
			}
			
		};
		
		
		var actionActivateDisable = function(record) {
			
			if (record.activeStatus !== 'A') {
				var loadMask = grid.showLoading('Activate Service Account...');
				Service.getApiService().activateServiceAccount(record.userId).then(function(){
					loadMask.remove();

					window.DL.MessageUtil.showToast('Success', 'Activated Service Account: ' + record.userId, {									
						theme: 'success'
					});
					actionRefresh();
				});
			} else {
				var loadMask = grid.showLoading('Inactive Service Account...');
				Service.getApiService().inactivateServiceAccount(record.userId).then(function(){
					loadMask.remove();

					window.DL.MessageUtil.showToast('Success', 'Inactivated Service Account: ' + record.userId, {									
						theme: 'success'
					});
					actionRefresh();
				});				
			}
		};
		
	}
	
};
customElements.define('dl-service-accounts-grid', ServiceAccountGrid);
